// How the web app hands the Chrome extension its API token: the web app's /extension page sends
// this with chrome.runtime.sendMessage, and the extension's service worker (background.ts) saves
// the token where the popup has always read it from. Shared so the two ends can't drift.

export const API_TOKEN_MESSAGE = "stashit:apiToken";

export interface ApiTokenMessage {
  type: typeof API_TOKEN_MESSAGE;
  token: string;
}

export const isApiTokenMessage = (message: unknown): message is ApiTokenMessage =>
  typeof message == "object" &&
  message != null &&
  (message as ApiTokenMessage).type == API_TOKEN_MESSAGE &&
  typeof (message as ApiTokenMessage).token == "string" &&
  (message as ApiTokenMessage).token.length > 0;
